export const DEFAULT_RELAYS = [
  "wss://nos.lol",
  "wss://relay.damus.io",
];

export const LOOKUP_RELAYS = [
  "wss://purplepag.es",
  "wss://index.hzrd149.com",
];
